"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHITESPACE = exports.END_OF_LINE = exports.COMMENT_START = exports.SEPARATOR = void 0;
exports.SEPARATOR = /[:=]/;
exports.COMMENT_START = /[#!]/;
exports.END_OF_LINE = /\r|\n|\r\n/;
exports.WHITESPACE = /[ \t\f]+/;
//# sourceMappingURL=constant.js.map